'use strict';
var $ = require(143);
var IS_PURE = require(166);
var anObject = require(117);
var getMapIterator = require(150);
var sameValueZero = require(190);
var iterate = require(167);

// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  includes: function includes(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value) {
      if (sameValueZero(value, searchElement)) return iterate.stop();
    }, undefined, true, true).stopped;
  }
});
